import React from "react";
import { Link, useParams } from "react-router-dom";
import { ROUTES } from "../../../constants/routes";
import {
  useLazyGetUserByIdDataQuery,
  useUserActionMutation,
} from "../../../store/api/userApi";
import ProfileImageComp from "../../common/profile";
import ProfileBadgeAvatar from "../user-profile/profile-avatar";

interface Member {
  first_name: string;
  last_name: string;
  profile_picture: string;
  _id: string;
  description: string;
  self: boolean;
  is_follows: boolean;
  memberships: {
    is_opc: boolean;
  };
  badge: string;
}

interface SuggestedUserProps {
  member: Member;
  refetchSuggestedUser: any;
}

const SuggestedUser: React.FC<SuggestedUserProps> = ({
  member,
  refetchSuggestedUser,
}) => {
  const description = member?.description || "";
  const [triggerUserAction] = useUserActionMutation();
  const { user_id } = useParams();
  const [refetchUserData] = useLazyGetUserByIdDataQuery();
  //   const [refetchSuggestedUsers] = useSuggestedUserQuery();

  const action = async ({ type }: { type: string }) => {
    await triggerUserAction({ user_id: member?._id, action: type });
    if (user_id) refetchUserData({ userId: user_id });
    refetchSuggestedUser();
  };

  return (
    <div className="flex items-center w-full justify-between space-x-2 my-2">
      <Link to={ROUTES.USER_PROFILE.replace(":user_id", member._id)}>
        <div className="flex gap-1">
          {member?.badge ? (
            <div className={`relative w-10 h-[40px]`}>
              <ProfileBadgeAvatar
                profileImage={member?.profile_picture}
                customDivClassName="absolute h-10 w-10 border-4  z-[2]"
                customImgClassName="h-[40px] w-[40px] absolute rounded-full p-[3px] z-[2]"
                customIconDivClassName="absolute z-[2] -bottom-[5px] left-[15px]"
                customStyle1="w-[50px] h-[14px]  absolute -bottom-2 z-[100] overflow-hidden"
                customStyle2="w-[200px] h-4 absolute top-3 z-[10] -left-10 overflow-hidden"
                customStarWidth={10}
                customStarHeight={10}
                customStyle3="w-[34px] h-[34px]"
                badge={member?.badge}
              />
            </div>
          ) : (
            <ProfileImageComp
              imageUrl={member?.profile_picture}
              customClass="h-9 w-9"
              is_opc={member?.memberships?.is_opc}
            />
          )}
          <div className="flex flex-col justify-center ml-1">
            <h6 className="text-sm">
              {member.first_name + " " + member.last_name}
            </h6>
            <p className="text-xs text-gray-600">
              {description.length > 30
                ? description.substring(0, 30) + "..."
                : description}
            </p>
          </div>
        </div>
      </Link>
      {member.self || member.is_follows ? (
        <h5
          className="text-sm text-[#007AFF] font-semibold cursor-pointer"
          onClick={() => action({ type: "unfollow" })}
        >
          Following
        </h5>
      ) : (
        <h5
          className="text-sm text-[#007AFF] font-semibold cursor-pointer"
          onClick={() => action({ type: "follow" })}
        >
          + Follow
        </h5>
      )}
    </div>
  );
};

export default SuggestedUser;
